import AppIcon from "@/common/components/Icons/AppIcon";
import { useApiRequest } from "@/common/hooks/api/useApiRequest";
import { apiClient } from "@/core/api/ApiClient";
import { RepairSparePartDto, RepairSparePartReferenceDto } from "@/core/api/generated/v1";

import BaseEntityInline, {
  BaseEntityInlineInheritableProps,
} from "../components/EntityInline/BaseEntityInline";
import { getRepairSparePartOptionTitle } from "./RepairSparePartAutocomplete";

export interface RepairSparePartInlineProps extends BaseEntityInlineInheritableProps {
  entity: RepairSparePartDto | RepairSparePartReferenceDto | null | undefined;
  entityId?: string | null;
}

export default function RepairSparePartInline({
  entity,
  entityId,
  ...otherProps
}: RepairSparePartInlineProps) {
  const request = useApiRequest(
    apiClient.repairSparePartApi.apiV1RepairSparePartsRepairSparePartIdGet,
    {
      nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
      repairSparePartId: entityId!,
    },
    {
      deps: [entityId],
      skip: !entityId || !!entity,
    },
  );
  entity = request?.data || entity;

  const full = entity as RepairSparePartDto;
  // const ref = entity as RepairSparePartReferenceDto;

  return (
    <BaseEntityInline
      entity={entity}
      entityId={entityId}
      request={request}
      icon={<AppIcon of='repairSparePart' inText />}
      content={<>{full && getRepairSparePartOptionTitle(full)} </>}
      {...otherProps}
      tooltipTitle={otherProps?.tooltipTitle || "Repair spare part"}
    />
  );
}
